import { Component, ContentChildren, EventEmitter, QueryList, Output, ViewEncapsulation, AfterContentInit } from '@angular/core';

import { PuiNavItemComponent } from './nav-item.component';
import { Router } from '@angular/router';

@Component({
  selector: 'pui-nav',
  styleUrls: ['nav.component.scss'],
  templateUrl: 'nav.component.html',
  encapsulation: ViewEncapsulation.None
})
export class PuiNavComponent implements AfterContentInit {
  // @Input() selected: any;
  @ContentChildren(PuiNavItemComponent) items: QueryList<PuiNavItemComponent>;
  @Output() select: EventEmitter<PuiNavItemComponent> = new EventEmitter<PuiNavItemComponent>();

  constructor(private router: Router) {}

  ngAfterContentInit() {
    // the initial (select) event
    this.items.forEach(item => {
      let url = item.link.urlTree;
      if (url && this.router.isActive(url, false)) {
        this.select.emit(item);
      }
    });
  }
}
